function accessibilityFixes() {
	if (typeof document === 'undefined') return;

    function fixRecaptchaElements() {
        var nodes = document.querySelectorAll('button.g-recaptcha[tabindex="-1"], textarea.g-recaptcha-response');

        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            if (!el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
            if (!el.hasAttribute('hidden')) el.setAttribute('hidden', '');
            el.hidden = true;
        }
    }

    function setupIframeObserver() {
        if (!window.MutationObserver) return;

        function fixIframesMissingTitle(root) {
            var container = root || document;
            if (!container.querySelectorAll) return;

            var iframes = container.querySelectorAll('iframe:not([title])');
            for (var i = 0; i < iframes.length; i++) {
                iframes[i].setAttribute('title', 'Security verification');
            }
        }

        // Fix any iframes already present at load.
        fixIframesMissingTitle(document);

        var observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var mutation = mutations[i];

                for (var j = 0; j < mutation.addedNodes.length; j++) {
                    var node = mutation.addedNodes[j];
                    if (!node || node.nodeType !== 1) continue;

                    // Fix the node itself (if iframe) + any descendant iframes.
                    if (node.tagName === 'IFRAME' && !node.hasAttribute('title')) {
                        node.setAttribute('title', 'Security verification');
                    }
                    fixIframesMissingTitle(node);
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    fixRecaptchaElements();
    setupIframeObserver();

}

export default accessibilityFixes